import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Coupon } from '../../models/coupon.interface';

@Injectable({
  providedIn: 'root'
})
export class CouponService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/coupons`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getCoupons(): Observable<Coupon[]> {
    return this.http.get<Coupon[]>(this.apiUrl);
  }

  getCouponById(id: string): Observable<Coupon> {
    return this.http.get<Coupon>(`${this.apiUrl}/${id}`);
  }

  createCoupon(couponData: Partial<Coupon>): Observable<Coupon> {
    return this.http.post<Coupon>(this.apiUrl, couponData);
  }

  updateCoupon(id: string, couponData: Partial<Coupon>): Observable<Coupon> {
    return this.http.put<Coupon>(`${this.apiUrl}/${id}`, couponData);
  }

  deleteCoupon(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}
